// extracted by mini-css-extract-plugin
export default {"game-name":"GssfYFmSACrEcV__60i6","game-name-inner":"WgvL7QJpjx0rDWGTRG_D","common_bganimation":"WCGc0UyTDG10a0CWA94z"};